import {minLength, regex} from "admin-on-rest";

export const validatePartnerDataCreate = (values, {translate}) => {
  const errors = {};
  if (!values.first_name || values.first_name.trim() === "") {
    errors.first_name = translate("resources.storeOwners.validation.firstName");
  }

  if (!values.last_name || values.last_name.trim() === "") {
    errors.last_name = translate("resources.storeOwners.validation.lastName");
  }

  if (!values.email || values.email.trim() === "") {
    errors.email = translate("resources.storeOwners.validation.email");
  }

  if (!values.password || values.password.trim() === "") {
    errors.password = translate("resources.storeOwners.validation.password");
  }
  if (!values.password2 || values.password2.trim() === "") {
    errors.password2 = translate(
      "resources.storeOwners.validation.repeatPassword"
    );
  }
  if (values.password && !values.password2) {
    errors.password2 = translate(
      "resources.storeOwners.validation.repeatPassword"
    );
  }
  if (!values.password && values.password2) {
    errors.password = translate("resources.storeOwners.validation.password");
  }
  if (
    values.password &&
    values.password2 &&
    values.password !== values.password2
  ) {
    errors.password = translate(
      "resources.storeOwners.validation.matchPasswords"
    );
    errors.password2 = translate(
      "resources.storeOwners.validation.matchPasswords"
    );
  }

  if (!values.company_name || values.company_name.trim() === "") {
    errors.company_name = translate(
      "resources.storeOwners.validation.companyName"
    );
  }
  if (!values.company_number || values.company_number.trim() === "") {
    errors.company_number = translate(
      "resources.storeOwners.validation.companyNumber"
    );
  }
  if (!values.city || values.city.trim() === "") {
    errors.city = translate("resources.storeOwners.validation.city");
  }
  if (!values.post_number || values.post_number.trim() === "") {
    errors.post_number = translate(
      "resources.storeOwners.validation.postNumber"
    );
  }

  return errors;
};

export const validatePartnerDataEdit = (values, {translate}) => {
  const errors = {};
  if (!values.first_name || values.first_name.trim() === "") {
    errors.first_name = translate("resources.storeOwners.validation.firstName");
  }

  if (!values.last_name || values.last_name.trim() === "") {
    errors.last_name = translate("resources.storeOwners.validation.lastName");
  }

  if (!values.email || values.email.trim() === "") {
    errors.email = translate("resources.storeOwners.validation.email");
  }
  if (values.password && !values.password2) {
    errors.password2 = translate(
      "resources.storeOwners.validation.repeatPassword"
    );
  }
  if (!values.password && values.password2) {
    errors.password = translate("resources.storeOwners.validation.password");
  }
  if (
    values.password &&
    values.password2 &&
    values.password !== values.password2
  ) {
    errors.password = translate(
      "resources.storeOwners.validation.matchPasswords"
    );
    errors.password2 = translate(
      "resources.storeOwners.validation.matchPasswords"
    );
  }

  if (!values.company_name || values.company_name.trim() === "") {
    errors.company_name = translate(
      "resources.storeOwners.validation.companyName"
    );
  }
  if (!values.company_number || values.company_number.trim() === "") {
    errors.company_number = translate(
      "resources.storeOwners.validation.companyNumber"
    );
  }
  if (!values.city || values.city.trim() === "") {
    errors.city = translate("resources.storeOwners.validation.city");
  }
  if (!values.post_number || values.post_number.trim() === "") {
    errors.post_number = translate(
      "resources.storeOwners.validation.postNumber"
    );
  }

  return errors;
};

export const validatePassword = [minLength(6)];
export const validateCompanyNumber = regex(
  /^[0-9---(-)]{10,15}$/,
  "resources.storeOwners.validation.validateCompanyNumber"
);
export const validateZipCode = regex(
  /^[0-9- ]{5,6}$/,
  "resources.storeOwners.validation.validateZipCode"
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/validations.js